




















import { Component, Prop, Vue } from "vue-property-decorator";
import userSettings from "@/components/userSettings.vue";
import teamChange from "@/components/teamChange.vue";
import reviewManageRubric from "@/components/review/reviewManageRubric.vue";
import { Team, User } from "@/types";
import { Getter } from "vuex-class";

@Component({
  components: {
    userSettings,
    teamChange,
    reviewManageRubric,
  }
})
export default class ManageRubric extends Vue {
  @Getter private currentTeamUsers?: User[];
  @Getter private currentTeam?: Team;
  @Prop() private changeTeam!: (teamID: any) => any;
}
